<template>
  <div>
    <div v-if="data && data.length <= 0">
      <b-card class="mt-0 border-0 text-center bg-secoundary">
        <img src="@/assets/inbox (1).png" width="30" alt="">
        <h6 class="text-black-50 text-light">Nada que mostrar</h6>
      </b-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "TableEmpty",
  props: [
    "data"
  ]
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/utils/TableEmpty.vue